module.exports = __webpack_public_path__ + "img/darkrose.65a72095.png";